import { Inject, Injectable } from '@angular/core';
import { SGKC024AService, Sgkc024aRequest } from 'sg-api';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

/**
 * スライド調整単価一覧表出力API使用サービス
 * @export
 * @class UsedSgkc024aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc024aService {
    /**
     * コンストラクタ
     * @param {SGKC024AService} sGKC024AService
     * @param {ApiCommonService} apiCommonService
     * @param {TimeApiService} timeApiService
     * @param {FeaturesLibConfig} featuresLibConfig
     * @memberof UsedSgkc024aService
     */
    constructor(
        private sGKC024AService: SGKC024AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig,
    ) {
    }
    
    /**
     * スライド調整単価一覧表出力API呼び出し
    * @param {Sgkc024aRequest} request
    * @param {boolean} [noCheckError=false] 
    * @return {Observable<boolean>} 
    * @memberof UsedSgkc024aService
    */
    outputSlideTanka(request: Sgkc024aRequest, noCheckError = false): Observable<boolean> {
        //日付のフォーマットをYYMMDDに変更
        this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
        let ret: Observable<boolean> = null;
        ret = this.sGKC024AService.kC10RSGKC024APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
            .pipe(
                map((response) => {
                    // コンテントタイプを取得
                    const contentType = response.headers.get('Content-Type');

                    if (contentType === 'application/octet-stream') {
                        // ファイルが取得できた場合																							

                        const fileBlob = new Blob([response.body], { type: contentType });
                        const contentDisposition: string = response.headers.get('Content-Disposition');
                        // 正規表現を使って、文字列からファイル名の抽出																						
                        const matchesFileName: RegExpExecArray = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                        // matchesFileName[1] に含まれるクォーテーション（' または "）をすべて削除しています																							
                        const fileName: string = matchesFileName[1].replace(/['"]/g, '');
                        // ヘッダ名「file-name」だった場合																																														
                        const fileNameDecode: string = decodeURIComponent(fileName);
                        // ファイルとしてダウンロード
                        this.anchorDownload(fileBlob, fileNameDecode, document);
                        return true;
                    } else if (this.sGKC024AService.configuration.isJsonMime(contentType)) {
                        // JSONとして処理
                        const textDecoder = new TextDecoder('utf-8');
                         // ArrayBufferを文字列に変換
                        const jsonString = textDecoder.decode(response.body);
                        // JSONオブジェクトに変換
                        const jsonResponse = JSON.parse(jsonString); 
                        this.apiCommonService.checkError(response.clone({ body: jsonResponse }));
                        return false;
                    }
                }),

                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC024A');
                    return throwError(err.message);
                })
            );
        return ret;
    }

    /**
     * 渡されたBlobオブジェクトとファイル名を元に内部でAnchor要素を作成し、
     * ブラウザ上でファイルとしてダウンロードする
     * @param {Blob} response
     * @param {string} filename
     * @param {Document} document
     * @memberof UsedSgkc024aService
     */
    anchorDownload(response: Blob, filename: string, document: Document): void {
        // 取得した情報をアンカー要素のURLに指定
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(response);
        // ダウンロード属性を指定して、ファイルとしてダウンロードするように指定
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        // アンカー要素をクリックしてダウンロード
        downloadLink.click();
        // 追加した要素を削除
        document.body.removeChild(downloadLink);
    }
}


